module.exports = __webpack_public_path__ + "img/846556_503E33_61493D_5C4434-256px.427d397e.png";